import React from 'react';

const Apple = props => {
  return (
   <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 0V2C22 3.06087 21.5786 4.07828 20.8284 4.82843C20.0783 5.57857 19.0609 6 18 6V4C18 2.93913 18.4214 1.92172 19.1716 1.17157C19.9217 0.421427 20.9391 0 22 0V0Z" fill="#FAB218"/>
    <path d="M9 20V16" stroke="#FAB218" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square"/>
    <path d="M5 18V16" stroke="#FAB218" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square"/>
    <path d="M13 18V16" stroke="#FAB218" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square"/>
    <path d="M17 20V16" stroke="#FAB218" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square"/>
    <path d="M5.913 12H3C2.46957 12 1.96086 12.2107 1.58579 12.5858C1.21071 12.9609 1 13.4696 1 14C1 14.5304 1.21071 15.0391 1.58579 15.4142C1.96086 15.7893 2.46957 16 3 16" stroke="#FAB218" strokeWidth="2" strokeMiterlimit="10"/>
    <path d="M6.52011 24C6.87309 24.8139 7.28242 25.6021 7.74511 26.359C11.7221 32.835 15.7321 30.64 18.0001 30.64C20.2681 30.64 24.2791 32.84 28.2561 26.359C32.3971 19.612 31.3821 11.974 28.3011 9.45901C24.9521 6.71401 21.1841 8.69001 18.0011 8.69001C14.8181 8.69001 11.0411 6.71401 7.70111 9.45901C6.21111 10.671 5.21511 13.08 5.03711 16" stroke="#FAB218" strokeWidth="2" strokeMiterlimit="10"/>
    <path d="M3 16H21V24H3C2.46957 24 1.96086 23.7893 1.58579 23.4142C1.21071 23.0391 1 22.5304 1 22V14" stroke="#FAB218" strokeWidth="2" strokeMiterlimit="10"/>
  </svg>
  );
};

export default Apple;



// WEBPACK FOOTER //
// ./src/svg/Apple.js